module.exports = __webpack_public_path__ + "static/media/hn.9758b8f7.svg";